import React from 'react';
import Modal from '@components/ui/general/Modal';
import LoadoutSelector from './LoadoutSelector';
import { useT } from '@/i18n';
import './HumanConfigModal.css';

/**
 * Modal para configurar la plantilla de unidades del jugador humano
 * Usa el componente Modal genérico para consistencia
 */
export default function HumanConfigModal({
  isOpen,
  onClose,
  loadoutTemplates = [],
  activeCategory = 'custom_unsaved',
  appliedLoadoutId = null,
  purchasedUnits = [],
  onApplyLoadout,
  onRegenerateRandom,
  onSwitchToCustom,
  onCreateLoadout,
  onUpdateLoadout,
  onDeleteLoadout,
  isApplying,
  isSwitchingToCustom,
  isLoadingTemplates,
  isCreatingLoadout,
  isUpdatingLoadout,
  isDeletingLoadout,
  maxCustomTemplates, // Required - no fallback
  onGoToShop,
}) {
  const t = useT();

  const handleGoToShop = () => {
    onClose();
    onGoToShop?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('human_config.title')}
      className="human-config-modal"
    >
      <div className="human-config-content">
        <LoadoutSelector
          loadoutTemplates={loadoutTemplates}
          activeCategory={activeCategory}
          appliedLoadoutId={appliedLoadoutId}
          purchasedUnits={purchasedUnits}
          onApplyLoadout={onApplyLoadout}
          onRegenerateRandom={onRegenerateRandom}
          onSwitchToCustom={onSwitchToCustom}
          onCreateLoadout={onCreateLoadout}
          onUpdateLoadout={onUpdateLoadout}
          onDeleteLoadout={onDeleteLoadout}
          onGoToShop={handleGoToShop}
          isApplying={isApplying}
          isSwitchingToCustom={isSwitchingToCustom}
          isLoading={isLoadingTemplates}
          isCreatingLoadout={isCreatingLoadout}
          isUpdatingLoadout={isUpdatingLoadout}
          isDeletingLoadout={isDeletingLoadout}
          maxCustomTemplates={maxCustomTemplates}
        />
      </div>
    </Modal>
  );
}
